import React from "react";
import BGDEnable from "../components/BGDEnable/index.jsx";

const BGDEnablePage = () => {
    return (
        <>
            <BGDEnable />
        </>
    );
};

export default BGDEnablePage;
